import { InternshipsTable } from "./_components/InternshipsTable";

export default function CurrentInternshipsPage() {
  return (
    <InternshipsTable
      isAlumni={false}
      heading="PGM Program Internships"
      body="Search for or view all current student internships associated with this PGM University Program"
      searchPlaceholder="Search Students"
      testId="students-table"
      showStatusFilter={true}
      showActionButtons={true}
    />
  );
}
